import React from "react";

import {icomoonUrl} from "../../src/components/_common/_constants";

export const IMAGE_DIMENSIONS = {
  width: 1200,
  height: 630,
};

const fontPaths = [
  "campton-book",
  "campton-medium",
  "campton-light",
  "campton-semibold",
  "campton-bold",
  "monosten-regular",
  "monosten-light",
];

export const OgImage: React.FC<{children: React.ReactElement; root?: string}> = ({
  children,
  root = "https://carbonhealth.com",
}) => (
  <html lang="en" style={IMAGE_DIMENSIONS}>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="stylesheet" href={icomoonUrl} />
      <link rel="stylesheet" href={`${root}/static/css/site.css`} />
      <link rel="stylesheet" href={`${root}/static/css/tailwind.css`} />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />
      {fontPaths.map(f => (
        <link key={f} href={`${root}/static/fonts/${f}.woff2`} rel="stylesheet" type="font/woff2" />
      ))}
    </head>
    <body>{children}</body>
  </html>
);
